module.exports = "query {\n    onBoardingTypeReward\n}\n"